export const GET_CARTS = "GET_CARTS";
export const GET_CURRENT_CART = "GET_CURRENT_CART";
export const GET_CART_BY_ID = "GET_CART_BY_ID";
export const UPDATE_CART = "UPDATE_CART";
export const DELETE_CART = "DELETE_CART";
export const CREATE_CART = "CREATE_CART";
export const PAY_CART = "PAY_CART";
export const VALIDATE_CART = "VALIDATE_CART";
